import React, { Component } from "react";
import { Line, Bar, Pie, Doughnut } from "react-chartjs-2";

import {} from "react-bootstrap";
import styled from "styled-components";

import firebase from "firebase";
import "firebase/database";
import "firebase/auth";
import { Paper } from "@material-ui/core";
import { getLogoURL } from "../util.js";
import { Button, Table, ButtonGroup, Dropdown } from "react-bootstrap";
import Divider from "@material-ui/core/Divider";
import moment from "moment";
import PageNotFound from "./pageNotFound";
import InterviewQuestions from "./interviewQuestions";
import {
  CBadge,
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CCol,
  CProgress,
  CRow,
  CCallout,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
// import { CChartLine } from "@coreui/react";
import MyLineChart from "./my-line-chart.js";
// import { CChartLine } from "@coreui/react-chartjs";

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
`;

const Col = styled.div`
  display: flex;
  flex-direction: col;
  align-items: center;
  padding: 10px;
  width: 100%;
`;

class Company extends Component {
  constructor() {
    super();
    this.jobCategories = {
      swe: "Software Engineering",
      ds: "Data Science",
      pm: "Product Manager",
      qr: "Quant",
      ml: "Machine Learning",
      ba: "Business Analytics",
      other: "Other",
    };

    this.invJobCategories = {
      "Software Engineering": "swe",
      "Data Science": "ds",
      "Product Manager": "pm",
      Quant: "qr",
      "Machine Learning": "ml",
      "Business Analytics": "ba",
      Other: "other",
    };

    this.state = {
      companyInfo: {},
      isUndefined: false,
    };
  }

  async writeTestDB() {
    const user = firebase.auth().currentUser;
    if (user) {
      // User is signed in.
    } else {
      // No user is signed in.
      const provider = new firebase.auth.GoogleAuthProvider();
      console.log("provider", provider);
      await firebase.auth().signInWithPopup(provider).catch(console.log);
    }

    const dates = {};

    for (let i = 0; i < 100; i++) {
      const randomMonth = parseInt(Math.random() * 7 + 1);
      const randomDate = parseInt(Math.random() * 30 + 1);

      if (dates[randomMonth] == undefined || dates[randomMonth] == null) {
        dates[randomMonth] = {};
      }

      dates[randomMonth][randomDate.toString()] = {
        numApplied: parseInt(Math.random() * 50 + 1),
        numFirstRound: parseInt(Math.random() * 30),
        numSecondRound: parseInt(Math.random() * 20),
        numThirdRound: parseInt(Math.random() * 18),
        numFourthRound: parseInt(Math.random() * 16),
        numOffered: parseInt(Math.random() * 10),
        numRejected: parseInt(Math.random() * 10),
      };
    }

    Object.keys(dates).forEach((month) => {
      const dateRef = firebase
        .firestore()
        .collection("companies/" + this.state.companyInfo.id + "/dates")
        .doc("2021-" + month);

      dateRef.get().then((docSnapshot) => {
        if (docSnapshot.exists) {
          dateRef.onSnapshot((doc) => {
            dateRef.update(dates[month]);
          });
        } else {
          dateRef.set(dates[month]); // create the document
        }
      });
    });
    console.log("This worked");
  }

  async componentDidMount() {
    const companyId = this.props.match.params.id.replace(/_/g, " ");
    console.log(companyId, "id");
    const displayCategory =
      this.jobCategories[this.props.match.params.category];
    console.log(companyId, "id");
    console.log(displayCategory, "displ");
    if (displayCategory == undefined) {
      this.setState({ isUndefined: true });
    } else {
      const companyDocuments = await firebase
        .firestore()
        .collection(this.invJobCategories[displayCategory])
        .doc(companyId)
        .get();

      console.log(companyDocuments == undefined, "gfewrgergre");

      const companyInfo = companyDocuments.data();
      if (companyInfo == undefined || !companyInfo["isPublic"]) {
        this.setState({ isUndefined: true });
      } else {
        companyInfo["url"] = getLogoURL(companyInfo.name);
        companyInfo["id"] = companyId;

        this.setState({
          companyInfo,
        });

        console.log("Company Info:", companyInfo);
        this.setState({ category: displayCategory });
      }
      // console.log("Company Dates:", companyDates);
    }
  }

  render() {
    // console.log(this.getLast7Days());
    const data = {
      labels: this.state.labels,
      datasets: [
        {
          label: "My First Dataset",
          data: this.state.totNumApplied,
          backgroundColor: [
            "rgba(255, 99, 132, 0.2)",
            "rgba(255, 159, 64, 0.2)",
            "rgba(255, 205, 86, 0.2)",
            "rgba(75, 192, 192, 0.2)",
            "rgba(54, 162, 235, 0.2)",
            "rgba(153, 102, 255, 0.2)",
            "rgba(201, 203, 207, 0.2)",
          ],
          borderColor: [
            "rgb(255, 99, 132)",
            "rgb(255, 159, 64)",
            "rgb(255, 205, 86)",
            "rgb(75, 192, 192)",
            "rgb(54, 162, 235)",
            "rgb(153, 102, 255)",
            "rgb(201, 203, 207)",
          ],
          borderWidth: 1,
        },
      ],
    };
    // const config = {
    //   c,
    // };

    if (this.state.isUndefined) return <PageNotFound />;

    return (
      // <Paper elevation={3} style={{ padding: 50, }}
      // variant="outlined" square={true}>
      <div className="container">
        {/* <Button onClick={this.writeTestDB.bind(this)}>writeToDB</Button> */}
        <div className="row" style={{ justifyContent: "center" }}>
          <div
            className="col-2"
            style={{ justifyContent: "center", alignItems: "center" }}
          >
            <Dropdown
              className="mx-auto"
              // variant="secondary"
              style={{ justifyContent: "center", alignSelf: "center" }}
            >
              <Dropdown.Toggle
                variant="outline-secondary"
                className="mt-3"
                id="dropdown-basic"
              >
                {this.state.category}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {Object.keys(this.invJobCategories).map((cat) => {
                  return (
                    <Dropdown.Item
                      active={cat == this.state.category}
                      onClick={(e) => {
                        this.props.history.push(
                          "/company/" +
                            this.state.companyInfo.name.replace(/ /g, "_") +
                            "/" +
                            this.invJobCategories[cat]
                        );
                      }}
                    >
                      {cat}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <div className="mt-1 mb-4">
          <a href="/">&#8592;HOME</a>
        </div>

        <div
          className="row mx-1"
          style={
            {
              // background: "blue",
              // alignItems: "center",
            }
          }
        >
          <div
            className="col-12 col-md-7"
            style={{
              // background: "red",
              textAlign: "center",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div className="row" style={{ alignItems: "center" }}>
              <div
                className="col-3 col-md-3 col-lg-2 m-auto"
                style={
                  {
                    // background: "pink",
                  }
                }
              >
                <img
                  src={this.state.companyInfo.url}
                  alt="company logo"
                  style={{
                    width: "85px",

                    borderRadius: "25%",

                    padding: "5px",
                  }}
                />
              </div>
              <div
                className="col-9 col-md-9 col-lg-10"
                style={{ textAlign: "left" }}
              >
                <h1>{this.state.companyInfo.name}</h1>
              </div>
            </div>
          </div>
          <div
            className="col-12 col-md-5 m-auto"
            // style={{ background: "yellow" }}
            // style={{ textAlign: "right", alignItems: "right" }}
          >
            <h2 className="text-left text-md-right">Recruiting Status</h2>
          </div>
        </div>

        {/* <div className="row" style={{ marginTop: "50px" }}>
          <h3>This Week's Status Trends</h3>
          <hr />
          <p className="m-1 pb-4" style={{ fontSize: "1.2em" }}>
            Changes in the different statuses seen by our chrome extension users
            are listed here.{" "}
          </p>
        </div> */}

        <div className="row" style={{ marginTop: "50px" }}>
          <h3>Status Trends (Aug 2021- July 2022)</h3>
          <hr />

          <CCard>
            <CCardBody>
              {this.state.category && (
                <MyLineChart
                  style={{ height: "300px", marginTop: "40px" }}
                  companyid={this.props.match.params.id.replace(/_/g, " ")}
                  displaycategory={this.state.category}
                />
              )}
            </CCardBody>
            {/* <CCardFooter>
              <CRow className="text-center">
                <CCol md sm="12" className="mb-sm-2 mb-0">
                  <div className="text-muted">Visits</div>
                  <strong>29.703 Users (40%)</strong>
                  <CProgress
                    className="progress-xs mt-2"
                    precision={1}
                    color="success"
                    value={40}
                  />
                </CCol>
                <CCol md sm="12" className="mb-sm-2 mb-0 d-md-down-none">
                  <div className="text-muted">Unique</div>
                  <strong>24.093 Users (20%)</strong>
                  <CProgress
                    className="progress-xs mt-2"
                    precision={1}
                    color="info"
                    value={40}
                  />
                </CCol>
                <CCol md sm="12" className="mb-sm-2 mb-0">
                  <div className="text-muted">Pageviews</div>
                  <strong>78.706 Views (60%)</strong>
                  <CProgress
                    className="progress-xs mt-2"
                    precision={1}
                    color="warning"
                    value={40}
                  />
                </CCol>
                <CCol md sm="12" className="mb-sm-2 mb-0">
                  <div className="text-muted">New Users</div>
                  <strong>22.123 Users (80%)</strong>
                  <CProgress
                    className="progress-xs mt-2"
                    precision={1}
                    color="danger"
                    value={40}
                  />
                </CCol>
                <CCol md sm="12" className="mb-sm-2 mb-0 d-md-down-none">
                  <div className="text-muted">Bounce Rate</div>
                  <strong>Average Rate (40.15%)</strong>
                  <CProgress
                    className="progress-xs mt-2"
                    precision={1}
                    value={40}
                  />
                </CCol>
              </CRow>
            </CCardFooter> */}
          </CCard>

          {/* <Divider /> */}
        </div>

        <div className="row" style={{ marginTop: "50px" }}>
          <h3>Interview Questions</h3>
          <hr />
          {this.state.category && (
            <InterviewQuestions
              companyid={this.props.match.params.id.replace(/_/g, " ")}
              displaycategory={this.state.category}
            />
          )}

          {/* <hr /> */}
        </div>
      </div>

      // </Paper>
    );
  }
}

export default Company;
